import { encodeURIComponents } from "@configura/web-utilities";
/**
 * These methods aims to provide a default suggested way of building
 * URLs to Products and Catalogues. By using consistent URL:s copy-paste
 * between systems becomes easy and this can aid when debugging.
 * Using this format on URL is no requirement. In fact, most of our
 * integrators do not, as they do not expose the Catalogue-path.
 * Internally at Configura we try to stick with this format.
 */
export class CfgReferencePathHelper {
}
/**
 * Use to generate URLs in our reference format. This is the format Configura uses in our integrations.
 * @param browsingRootUrl The URL where Stage browsing begins
 * @param catParams What catalogue to generate URL for.
 * @returns An URL to a catalogue
 */
CfgReferencePathHelper.getCataloguePath = (browsingRootUrl, catParams) => `${browsingRootUrl}/${encodeURIComponents(catParams.cid, catParams.lang, catParams.enterprise, catParams.prdCat, catParams.prdCatVersion, catParams.vendor, catParams.priceList)}`;
/**
 * Use to generate URLs in our reference format. This is the format Configura uses in our integrations.
 * @param browsingRootUrl The URL where Stage browsing begins
 * @param productParams What product to generate URL for.
 * @param separator Optional, defaults to "product", but can be changed to indicate another function.
 * @returns An URL to a product
 */
CfgReferencePathHelper.getProductPath = (browsingRootUrl, productParams, separator = "product") => `${CfgReferencePathHelper.getCataloguePath(browsingRootUrl, productParams)}/${separator}/${encodeURIComponent(productParams.partNumber)}`;
